import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import SpinnerImage from '../../assets/images/spinner.png';

import './spinner.styles.css';

const Spinner = ({ hidesection }) => {

    const [getHideSpinner, setHideSpinner] = useState();
    useEffect(() => {
        let timer = setTimeout(function(){
            setHideSpinner(true);
        }, 5000);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    return(       
    <Container>
        <Row>
            <Col className='spinner-overlay section-center mb-5' xs='12' sm='12' md='7' lg='5'>
                {
                    hidesection === false ?
                        <Col sm='12' className={ `spinner-top ${ hidesection }` }>
                            <h3 className='mb-4'>My Customs status</h3>
                            {
                            getHideSpinner == null ?
                                <p>Please stay here!</p>
                            :
                                null
                            }
                        </Col>
                    :
                    null
                }

                {
                    getHideSpinner == null ?
                    <div className='spinner-conteiner'>
                        <img src={ SpinnerImage } alt='Spinner' />
                    </div>
                    :
                    <h3 className='text-center'>The information is not available</h3>
                }

                {
                    hidesection === false ?
                        <Col sm='12' className='spinner-bottom'>
                            <Link className='white-text' to='/'>
                                <FontAwesome className='arrow-left' name='arrow-left' />
                                <span className='prev-step'>Previous step</span>
                            </Link>
                        </Col>
                    :
                    null
                }
            </Col>
        </Row>
    </Container>
    );
};

export default Spinner;